import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import {$Elements, Elements, Breakpoints, BrowserEvents, Classes} from '../global/constants';
import {mediaQueryString} from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

;(function ($) {

    $Elements.document.on(BrowserEvents.page.enter, () => {

        // ---------- Variables ----------

        let mobileAnimations = [];
        let desktopAnimations = [];
        let globalAnimations = [];

        // ---------- Animated Section ----------

        $('.animated-section:not(.transition-clone)').each(function () {

            globalAnimations.push(() => {

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        once: true,
                        start: 'top 80%',
                        toggleClass: Classes.active,
                    }
                });
            });
        });

        // ---------- Shop Cat Links ----------

        if ($('.shop-cat-links').length) {

            $('.header-wrapper:not(.transition-clone)').each(function () {

                desktopAnimations.push(() => {

                    const cat_links = Elements.PageWrapper.querySelectorAll('.shop-cat-links');

                    const menu_height = $Elements.HeaderWrapper.outerHeight();

                    const timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: cat_links,
                            start: 'top ' + menu_height + 'px',
                            end: 'bottom ' + menu_height + 'px',
                            scrub: true,
                           // markers: true,
                        },
                    });

                    timeline.fromTo(this, {yPercent: 0}, {yPercent: -menu_height, ease: 'none'});
                });

            });

            $('.shop-cat-links:not(.transition-clone)').each(function () {

                desktopAnimations.push(() => {

                    const cat_sections = Elements.PageWrapper.querySelectorAll('.shop-cat-section');
                    const last_cat_section = cat_sections[cat_sections.length - 1];

                    const menu_height = $Elements.HeaderWrapper.outerHeight();
                    const shop_cat_links_height = $(this).outerHeight();
                    const end_offset = menu_height + shop_cat_links_height;

                    const timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: this,
                            start: 'top top',
                            endTrigger: '#' + last_cat_section.id,
                            end: 'top ' + shop_cat_links_height + 'px',
                            pin: true,
                            pinSpacing: false,
                            //markers: true,
                        }
                    });
                });

            });

            // function activate_link(section) {
            //     const link_id = section.id;
            //     $('.shop-cat-links').find('a').each(function(){
            //         $(this).removeClass('active');
            //     });
            //
            //     $('.shop-cat-links').find('a[href="#'+link_id+'"]').toggleClass('active');
            // }

            const sections = gsap.utils.toArray(".shop-cat-section");

            sections.forEach((section, index) => {
                desktopAnimations.push(() => {
                    ScrollTrigger.create({
                        trigger: section,
                        start: 'top center',
                        toggleClass: 'visible',
                       // onEnter: () => activate_link(section),
                       // onLeave: () => activate_link(section),
                       // markers: true,
                        end: () => {
                            return index === sections.length - 1
                                ? 'bottom center'
                                : 'bottom center';
                        },
                    });
                });
            });
        }

        // ---------- Shop Single Product ----------

        $('.product:not(.product_cat-coffrets) .entry-summary:not(.transition-clone)').each(function () {

            desktopAnimations.push(() => {

                const menu_height = $Elements.HeaderWrapper.outerHeight();

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: this,
                        start: '-500px top',
                        endTrigger: '.summary',
                        end: 'bottom bottom',
                        toggleClass: Classes.active,
                        //markers: true,
                    }
                });
            });

        });

        $('.cta-add-to-cart-mobile').each(function () {

            mobileAnimations.push(() => {

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.summary-wrapper',
                        start: 'bottom 10%',
                        endTrigger: '.product-content-section',
                        end: 'bottom 50%',
                        toggleClass: {targets: this, className: "active"},
                        //markers: true,
                    }
                });
            });

        });



        // ---------- Parallax Section ----------

        $('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function () {

            desktopAnimations.push(() => {

                const image = this.querySelector(':scope .section-image');
                const speed = 25;

                if (image) {

                    const timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: this,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                        },
                    });

                    timeline.fromTo(image, {yPercent: -speed}, {yPercent: speed, ease: 'none'});
                }
            });
        });

        $('.summary.entry-summary').each(function () {

            desktopAnimations.push(() => {

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        triggerElement: this,
                        start: 'top bottom',
                        end: 'bottom top',
                        //markers: true,
                    }
                });
            });
        });

        // ---------- Handle Media Queries ----------

        ScrollTrigger.matchMedia({

            // Desktop Animations
            [mediaQueryString(Breakpoints.Mobile)]: () => desktopAnimations.map(animation => animation()),

            // Mobile Animations
            [mediaQueryString(Breakpoints.Mobile, false)]: () => mobileAnimations.map(animation => animation()),

            // Global Animations
            'all': () => globalAnimations.map(animation => animation()),

        });

    });

}(jQuery));
